import { createRootRouteWithContext } from "@tanstack/react-router";

import { RouteError } from "@/app/error-boundary";
import { AppLayout } from "@/app/layout";
import { NotFound } from "@/app/not-found";
import type { RouterContext } from "@/app/router";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: AppLayout,
  errorComponent: RouteError,
  notFoundComponent: NotFound,
});
